import { render, staticRenderFns } from "./faqtable.vue?vue&type=template&id=ac85c9ec&scoped=true"
import script from "./faqtable.vue?vue&type=script&lang=js"
export * from "./faqtable.vue?vue&type=script&lang=js"
import style0 from "./faqtable.vue?vue&type=style&index=0&id=ac85c9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac85c9ec",
  null
  
)

export default component.exports